module.exports = __webpack_public_path__ + "static/media/placeholder_empty@2x.c5cdbe14.png";